import React from 'react';
import { Bot, Clock, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import * as api from '@/lib/api';

// Explains that platform data comes from the Desktop Agent and lets the user request a collection now
export const AgentCollectionBanner = ({ status, onRequested }) => {
  if (!status) return null;
  const { awaiting_agent, last_collected_at, pending_tasks, accounts_in_vault } = status;

  const request = async () => {
    try {
      const res = await api.requestAnalyticsRefresh();
      toast.success(res.data.message);
      onRequested?.();
    } catch {
      toast.error('Falha ao solicitar coleta');
    }
  };

  return (
    <div
      className={`flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-lg border px-4 py-3 ${awaiting_agent ? 'border-amber-500/30 bg-amber-500/5' : 'border-border bg-muted/30'}`}
      data-testid="agent-collection-banner"
    >
      <div className="flex items-start gap-3">
        <Bot className={`w-5 h-5 mt-0.5 ${awaiting_agent ? 'text-amber-400' : 'text-primary'}`} />
        <div className="text-sm">
          {awaiting_agent ? (
            <p className="font-medium" data-testid="awaiting-agent-text">
              Aguardando coleta do Agente Desktop
              {accounts_in_vault === 0 && ' — adicione contas no Cofre Seguro para começar'}
            </p>
          ) : (
            <p className="font-medium">Dados coletados manualmente pelo Agente Desktop</p>
          )}
          <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
            <Clock className="w-3 h-3" />
            {last_collected_at ? `Última coleta: ${new Date(last_collected_at).toLocaleString('pt-BR')}` : 'Nenhuma coleta ainda'}
            {pending_tasks > 0 && ` · ${pending_tasks} tarefa(s) na fila do Agente`}
            {' · atualização automática a cada hora'}
          </p>
        </div>
      </div>
      <Button size="sm" variant="outline" onClick={request} data-testid="request-agent-collection-btn">
        <RefreshCw className="w-3 h-3 mr-1" /> Solicitar coleta agora
      </Button>
    </div>
  );
};
